module.exports = __webpack_public_path__ + "fonts/DM_Sans-500-latin11.7c87a64.woff2";